/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './../routes/__root'
import { Route as ZoomSuccessImport } from './../routes/zoom-success'
import { Route as GoogleAuthCallbackImport } from './../routes/google-auth-callback'
import { Route as GoogleAuthImport } from './../routes/google-auth'
import { Route as AuthorizedImport } from './../routes/_authorized'
import { Route as AuthorizedIndexImport } from './../routes/_authorized/index'
import { Route as AuthorizedWelcomeGoogleImport } from './../routes/_authorized/welcome-google'
import { Route as AuthorizedWelcomeEventDeclinedImport } from './../routes/_authorized/welcome-event-declined'
import { Route as AuthorizedWelcomeEventImport } from './../routes/_authorized/welcome-event'
import { Route as AuthorizedWelcomeImport } from './../routes/_authorized/welcome'
import { Route as AuthorizedBirthdaysImport } from './../routes/_authorized/birthdays'
import { Route as AuthorizedWithTabsImport } from './../routes/_authorized/_withTabs'
import { Route as AuthorizedSettingsIndexImport } from './../routes/_authorized/settings/index'
import { Route as AuthorizedStacksNewImport } from './../routes/_authorized/stacks/new'
import { Route as AuthorizedSlotsVideoCallSettingsImport } from './../routes/_authorized/slots/video-call-settings'
import { Route as AuthorizedSlotsSettingsImport } from './../routes/_authorized/slots/settings'
import { Route as AuthorizedSlotsReadyImport } from './../routes/_authorized/slots/ready'
import { Route as AuthorizedSlotsOnboardingImport } from './../routes/_authorized/slots/onboarding'
import { Route as AuthorizedSlotsGoogleInitImport } from './../routes/_authorized/slots/google-init'
import { Route as AuthorizedSettingsVideoCallImport } from './../routes/_authorized/settings/video-call'
import { Route as AuthorizedSettingsNotificationsImport } from './../routes/_authorized/settings/notifications'
import { Route as AuthorizedSettingsCancelSubscriptionImport } from './../routes/_authorized/settings/cancel-subscription'
import { Route as AuthorizedSettingsAppearanceImport } from './../routes/_authorized/settings/appearance'
import { Route as AuthorizedEventsNewImport } from './../routes/_authorized/events/new'
import { Route as AuthorizedWithTabsStacksImport } from './../routes/_authorized/_withTabs/stacks'
import { Route as AuthorizedWithTabsSlotsImport } from './../routes/_authorized/_withTabs/slots'
import { Route as AuthorizedWithTabsFeedWelcomeImport } from './../routes/_authorized/_withTabs/feed-welcome'
import { Route as AuthorizedWithTabsFeedImport } from './../routes/_authorized/_withTabs/feed'
import { Route as AuthorizedStacksStackIdViewImport } from './../routes/_authorized/stacks/$stackId/view'
import { Route as AuthorizedStacksStackIdEditImport } from './../routes/_authorized/stacks/$stackId/edit'
import { Route as AuthorizedSlotsSlotIdViewImport } from './../routes/_authorized/slots/$slotId/view'
import { Route as AuthorizedSlotsEventIdAttendImport } from './../routes/_authorized/slots/$eventId/attend'
import { Route as AuthorizedSettingsGoogleAccountIdImport } from './../routes/_authorized/settings/google.$accountId'
import { Route as AuthorizedEventsEventIdViewImport } from './../routes/_authorized/events/$eventId/view'
import { Route as AuthorizedEventsEventIdStoriesShareImport } from './../routes/_authorized/events/$eventId/stories-share'
import { Route as AuthorizedEventsEventIdParticipantsImport } from './../routes/_authorized/events/$eventId/participants'
import { Route as AuthorizedEventsEventIdMaybeImport } from './../routes/_authorized/events/$eventId/maybe'
import { Route as AuthorizedEventsEventIdJoinImport } from './../routes/_authorized/events/$eventId/join'
import { Route as AuthorizedEventsEventIdEditImport } from './../routes/_authorized/events/$eventId/edit'
import { Route as AuthorizedEventsEventIdDraftImport } from './../routes/_authorized/events/$eventId/draft'
import { Route as AuthorizedEventsEventIdCreatedImport } from './../routes/_authorized/events/$eventId/created'
import { Route as AuthorizedEventsEventIdAttendImport } from './../routes/_authorized/events/$eventId/attend'
import { Route as AuthorizedSlotsEventIdSlotIdRescheduleImport } from './../routes/_authorized/slots/$eventId/$slotId/reschedule'

// Create/Update Routes

const ZoomSuccessRoute = ZoomSuccessImport.update({
  path: '/zoom-success',
  getParentRoute: () => rootRoute,
} as any)

const GoogleAuthCallbackRoute = GoogleAuthCallbackImport.update({
  path: '/google-auth-callback',
  getParentRoute: () => rootRoute,
} as any)

const GoogleAuthRoute = GoogleAuthImport.update({
  path: '/google-auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthorizedRoute = AuthorizedImport.update({
  id: '/_authorized',
  getParentRoute: () => rootRoute,
} as any)

const AuthorizedIndexRoute = AuthorizedIndexImport.update({
  path: '/',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedWelcomeGoogleRoute = AuthorizedWelcomeGoogleImport.update({
  path: '/welcome-google',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedWelcomeEventDeclinedRoute =
  AuthorizedWelcomeEventDeclinedImport.update({
    path: '/welcome-event-declined',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedWelcomeEventRoute = AuthorizedWelcomeEventImport.update({
  path: '/welcome-event',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedWelcomeRoute = AuthorizedWelcomeImport.update({
  path: '/welcome',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedBirthdaysRoute = AuthorizedBirthdaysImport.update({
  path: '/birthdays',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedWithTabsRoute = AuthorizedWithTabsImport.update({
  id: '/_withTabs',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSettingsIndexRoute = AuthorizedSettingsIndexImport.update({
  path: '/settings/',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedStacksNewRoute = AuthorizedStacksNewImport.update({
  path: '/stacks/new',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSlotsVideoCallSettingsRoute =
  AuthorizedSlotsVideoCallSettingsImport.update({
    path: '/slots/video-call-settings',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSlotsSettingsRoute = AuthorizedSlotsSettingsImport.update({
  path: '/slots/settings',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSlotsReadyRoute = AuthorizedSlotsReadyImport.update({
  path: '/slots/ready',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSlotsOnboardingRoute = AuthorizedSlotsOnboardingImport.update({
  path: '/slots/onboarding',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSlotsGoogleInitRoute = AuthorizedSlotsGoogleInitImport.update({
  path: '/slots/google-init',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSettingsVideoCallRoute =
  AuthorizedSettingsVideoCallImport.update({
    path: '/settings/video-call',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSettingsNotificationsRoute =
  AuthorizedSettingsNotificationsImport.update({
    path: '/settings/notifications',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSettingsCancelSubscriptionRoute =
  AuthorizedSettingsCancelSubscriptionImport.update({
    path: '/settings/cancel-subscription',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSettingsAppearanceRoute =
  AuthorizedSettingsAppearanceImport.update({
    path: '/settings/appearance',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsNewRoute = AuthorizedEventsNewImport.update({
  path: '/events/new',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedWithTabsStacksRoute = AuthorizedWithTabsStacksImport.update({
  path: '/stacks',
  getParentRoute: () => AuthorizedWithTabsRoute,
} as any)

const AuthorizedWithTabsSlotsRoute = AuthorizedWithTabsSlotsImport.update({
  path: '/slots',
  getParentRoute: () => AuthorizedWithTabsRoute,
} as any)

const AuthorizedWithTabsFeedWelcomeRoute =
  AuthorizedWithTabsFeedWelcomeImport.update({
    path: '/feed-welcome',
    getParentRoute: () => AuthorizedWithTabsRoute,
  } as any)

const AuthorizedWithTabsFeedRoute = AuthorizedWithTabsFeedImport.update({
  path: '/feed',
  getParentRoute: () => AuthorizedWithTabsRoute,
} as any)

const AuthorizedStacksStackIdViewRoute =
  AuthorizedStacksStackIdViewImport.update({
    path: '/stacks/$stackId/view',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedStacksStackIdEditRoute =
  AuthorizedStacksStackIdEditImport.update({
    path: '/stacks/$stackId/edit',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSlotsSlotIdViewRoute = AuthorizedSlotsSlotIdViewImport.update({
  path: '/slots/$slotId/view',
  getParentRoute: () => AuthorizedRoute,
} as any)

const AuthorizedSlotsEventIdAttendRoute =
  AuthorizedSlotsEventIdAttendImport.update({
    path: '/slots/$eventId/attend',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSettingsGoogleAccountIdRoute =
  AuthorizedSettingsGoogleAccountIdImport.update({
    path: '/settings/google/$accountId',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdViewRoute =
  AuthorizedEventsEventIdViewImport.update({
    path: '/events/$eventId/view',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdStoriesShareRoute =
  AuthorizedEventsEventIdStoriesShareImport.update({
    path: '/events/$eventId/stories-share',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdParticipantsRoute =
  AuthorizedEventsEventIdParticipantsImport.update({
    path: '/events/$eventId/participants',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdMaybeRoute =
  AuthorizedEventsEventIdMaybeImport.update({
    path: '/events/$eventId/maybe',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdJoinRoute =
  AuthorizedEventsEventIdJoinImport.update({
    path: '/events/$eventId/join',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdEditRoute =
  AuthorizedEventsEventIdEditImport.update({
    path: '/events/$eventId/edit',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdDraftRoute =
  AuthorizedEventsEventIdDraftImport.update({
    path: '/events/$eventId/draft',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdCreatedRoute =
  AuthorizedEventsEventIdCreatedImport.update({
    path: '/events/$eventId/created',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedEventsEventIdAttendRoute =
  AuthorizedEventsEventIdAttendImport.update({
    path: '/events/$eventId/attend',
    getParentRoute: () => AuthorizedRoute,
  } as any)

const AuthorizedSlotsEventIdSlotIdRescheduleRoute =
  AuthorizedSlotsEventIdSlotIdRescheduleImport.update({
    path: '/slots/$eventId/$slotId/reschedule',
    getParentRoute: () => AuthorizedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authorized': {
      id: '/_authorized'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthorizedImport
      parentRoute: typeof rootRoute
    }
    '/google-auth': {
      id: '/google-auth'
      path: '/google-auth'
      fullPath: '/google-auth'
      preLoaderRoute: typeof GoogleAuthImport
      parentRoute: typeof rootRoute
    }
    '/google-auth-callback': {
      id: '/google-auth-callback'
      path: '/google-auth-callback'
      fullPath: '/google-auth-callback'
      preLoaderRoute: typeof GoogleAuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/zoom-success': {
      id: '/zoom-success'
      path: '/zoom-success'
      fullPath: '/zoom-success'
      preLoaderRoute: typeof ZoomSuccessImport
      parentRoute: typeof rootRoute
    }
    '/_authorized/_withTabs': {
      id: '/_authorized/_withTabs'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthorizedWithTabsImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/birthdays': {
      id: '/_authorized/birthdays'
      path: '/birthdays'
      fullPath: '/birthdays'
      preLoaderRoute: typeof AuthorizedBirthdaysImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/welcome': {
      id: '/_authorized/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthorizedWelcomeImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/welcome-event': {
      id: '/_authorized/welcome-event'
      path: '/welcome-event'
      fullPath: '/welcome-event'
      preLoaderRoute: typeof AuthorizedWelcomeEventImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/welcome-event-declined': {
      id: '/_authorized/welcome-event-declined'
      path: '/welcome-event-declined'
      fullPath: '/welcome-event-declined'
      preLoaderRoute: typeof AuthorizedWelcomeEventDeclinedImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/welcome-google': {
      id: '/_authorized/welcome-google'
      path: '/welcome-google'
      fullPath: '/welcome-google'
      preLoaderRoute: typeof AuthorizedWelcomeGoogleImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/': {
      id: '/_authorized/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthorizedIndexImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/_withTabs/feed': {
      id: '/_authorized/_withTabs/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof AuthorizedWithTabsFeedImport
      parentRoute: typeof AuthorizedWithTabsImport
    }
    '/_authorized/_withTabs/feed-welcome': {
      id: '/_authorized/_withTabs/feed-welcome'
      path: '/feed-welcome'
      fullPath: '/feed-welcome'
      preLoaderRoute: typeof AuthorizedWithTabsFeedWelcomeImport
      parentRoute: typeof AuthorizedWithTabsImport
    }
    '/_authorized/_withTabs/slots': {
      id: '/_authorized/_withTabs/slots'
      path: '/slots'
      fullPath: '/slots'
      preLoaderRoute: typeof AuthorizedWithTabsSlotsImport
      parentRoute: typeof AuthorizedWithTabsImport
    }
    '/_authorized/_withTabs/stacks': {
      id: '/_authorized/_withTabs/stacks'
      path: '/stacks'
      fullPath: '/stacks'
      preLoaderRoute: typeof AuthorizedWithTabsStacksImport
      parentRoute: typeof AuthorizedWithTabsImport
    }
    '/_authorized/events/new': {
      id: '/_authorized/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthorizedEventsNewImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/settings/appearance': {
      id: '/_authorized/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthorizedSettingsAppearanceImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/settings/cancel-subscription': {
      id: '/_authorized/settings/cancel-subscription'
      path: '/settings/cancel-subscription'
      fullPath: '/settings/cancel-subscription'
      preLoaderRoute: typeof AuthorizedSettingsCancelSubscriptionImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/settings/notifications': {
      id: '/_authorized/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthorizedSettingsNotificationsImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/settings/video-call': {
      id: '/_authorized/settings/video-call'
      path: '/settings/video-call'
      fullPath: '/settings/video-call'
      preLoaderRoute: typeof AuthorizedSettingsVideoCallImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/google-init': {
      id: '/_authorized/slots/google-init'
      path: '/slots/google-init'
      fullPath: '/slots/google-init'
      preLoaderRoute: typeof AuthorizedSlotsGoogleInitImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/onboarding': {
      id: '/_authorized/slots/onboarding'
      path: '/slots/onboarding'
      fullPath: '/slots/onboarding'
      preLoaderRoute: typeof AuthorizedSlotsOnboardingImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/ready': {
      id: '/_authorized/slots/ready'
      path: '/slots/ready'
      fullPath: '/slots/ready'
      preLoaderRoute: typeof AuthorizedSlotsReadyImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/settings': {
      id: '/_authorized/slots/settings'
      path: '/slots/settings'
      fullPath: '/slots/settings'
      preLoaderRoute: typeof AuthorizedSlotsSettingsImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/video-call-settings': {
      id: '/_authorized/slots/video-call-settings'
      path: '/slots/video-call-settings'
      fullPath: '/slots/video-call-settings'
      preLoaderRoute: typeof AuthorizedSlotsVideoCallSettingsImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/stacks/new': {
      id: '/_authorized/stacks/new'
      path: '/stacks/new'
      fullPath: '/stacks/new'
      preLoaderRoute: typeof AuthorizedStacksNewImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/settings/': {
      id: '/_authorized/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthorizedSettingsIndexImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/attend': {
      id: '/_authorized/events/$eventId/attend'
      path: '/events/$eventId/attend'
      fullPath: '/events/$eventId/attend'
      preLoaderRoute: typeof AuthorizedEventsEventIdAttendImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/created': {
      id: '/_authorized/events/$eventId/created'
      path: '/events/$eventId/created'
      fullPath: '/events/$eventId/created'
      preLoaderRoute: typeof AuthorizedEventsEventIdCreatedImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/draft': {
      id: '/_authorized/events/$eventId/draft'
      path: '/events/$eventId/draft'
      fullPath: '/events/$eventId/draft'
      preLoaderRoute: typeof AuthorizedEventsEventIdDraftImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/edit': {
      id: '/_authorized/events/$eventId/edit'
      path: '/events/$eventId/edit'
      fullPath: '/events/$eventId/edit'
      preLoaderRoute: typeof AuthorizedEventsEventIdEditImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/join': {
      id: '/_authorized/events/$eventId/join'
      path: '/events/$eventId/join'
      fullPath: '/events/$eventId/join'
      preLoaderRoute: typeof AuthorizedEventsEventIdJoinImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/maybe': {
      id: '/_authorized/events/$eventId/maybe'
      path: '/events/$eventId/maybe'
      fullPath: '/events/$eventId/maybe'
      preLoaderRoute: typeof AuthorizedEventsEventIdMaybeImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/participants': {
      id: '/_authorized/events/$eventId/participants'
      path: '/events/$eventId/participants'
      fullPath: '/events/$eventId/participants'
      preLoaderRoute: typeof AuthorizedEventsEventIdParticipantsImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/stories-share': {
      id: '/_authorized/events/$eventId/stories-share'
      path: '/events/$eventId/stories-share'
      fullPath: '/events/$eventId/stories-share'
      preLoaderRoute: typeof AuthorizedEventsEventIdStoriesShareImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/events/$eventId/view': {
      id: '/_authorized/events/$eventId/view'
      path: '/events/$eventId/view'
      fullPath: '/events/$eventId/view'
      preLoaderRoute: typeof AuthorizedEventsEventIdViewImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/settings/google/$accountId': {
      id: '/_authorized/settings/google/$accountId'
      path: '/settings/google/$accountId'
      fullPath: '/settings/google/$accountId'
      preLoaderRoute: typeof AuthorizedSettingsGoogleAccountIdImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/$eventId/attend': {
      id: '/_authorized/slots/$eventId/attend'
      path: '/slots/$eventId/attend'
      fullPath: '/slots/$eventId/attend'
      preLoaderRoute: typeof AuthorizedSlotsEventIdAttendImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/$slotId/view': {
      id: '/_authorized/slots/$slotId/view'
      path: '/slots/$slotId/view'
      fullPath: '/slots/$slotId/view'
      preLoaderRoute: typeof AuthorizedSlotsSlotIdViewImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/stacks/$stackId/edit': {
      id: '/_authorized/stacks/$stackId/edit'
      path: '/stacks/$stackId/edit'
      fullPath: '/stacks/$stackId/edit'
      preLoaderRoute: typeof AuthorizedStacksStackIdEditImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/stacks/$stackId/view': {
      id: '/_authorized/stacks/$stackId/view'
      path: '/stacks/$stackId/view'
      fullPath: '/stacks/$stackId/view'
      preLoaderRoute: typeof AuthorizedStacksStackIdViewImport
      parentRoute: typeof AuthorizedImport
    }
    '/_authorized/slots/$eventId/$slotId/reschedule': {
      id: '/_authorized/slots/$eventId/$slotId/reschedule'
      path: '/slots/$eventId/$slotId/reschedule'
      fullPath: '/slots/$eventId/$slotId/reschedule'
      preLoaderRoute: typeof AuthorizedSlotsEventIdSlotIdRescheduleImport
      parentRoute: typeof AuthorizedImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  AuthorizedRoute: AuthorizedRoute.addChildren({
    AuthorizedWithTabsRoute: AuthorizedWithTabsRoute.addChildren({
      AuthorizedWithTabsFeedRoute,
      AuthorizedWithTabsFeedWelcomeRoute,
      AuthorizedWithTabsSlotsRoute,
      AuthorizedWithTabsStacksRoute,
    }),
    AuthorizedBirthdaysRoute,
    AuthorizedWelcomeRoute,
    AuthorizedWelcomeEventRoute,
    AuthorizedWelcomeEventDeclinedRoute,
    AuthorizedWelcomeGoogleRoute,
    AuthorizedIndexRoute,
    AuthorizedEventsNewRoute,
    AuthorizedSettingsAppearanceRoute,
    AuthorizedSettingsCancelSubscriptionRoute,
    AuthorizedSettingsNotificationsRoute,
    AuthorizedSettingsVideoCallRoute,
    AuthorizedSlotsGoogleInitRoute,
    AuthorizedSlotsOnboardingRoute,
    AuthorizedSlotsReadyRoute,
    AuthorizedSlotsSettingsRoute,
    AuthorizedSlotsVideoCallSettingsRoute,
    AuthorizedStacksNewRoute,
    AuthorizedSettingsIndexRoute,
    AuthorizedEventsEventIdAttendRoute,
    AuthorizedEventsEventIdCreatedRoute,
    AuthorizedEventsEventIdDraftRoute,
    AuthorizedEventsEventIdEditRoute,
    AuthorizedEventsEventIdJoinRoute,
    AuthorizedEventsEventIdMaybeRoute,
    AuthorizedEventsEventIdParticipantsRoute,
    AuthorizedEventsEventIdStoriesShareRoute,
    AuthorizedEventsEventIdViewRoute,
    AuthorizedSettingsGoogleAccountIdRoute,
    AuthorizedSlotsEventIdAttendRoute,
    AuthorizedSlotsSlotIdViewRoute,
    AuthorizedStacksStackIdEditRoute,
    AuthorizedStacksStackIdViewRoute,
    AuthorizedSlotsEventIdSlotIdRescheduleRoute,
  }),
  GoogleAuthRoute,
  GoogleAuthCallbackRoute,
  ZoomSuccessRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authorized",
        "/google-auth",
        "/google-auth-callback",
        "/zoom-success"
      ]
    },
    "/_authorized": {
      "filePath": "_authorized.tsx",
      "children": [
        "/_authorized/_withTabs",
        "/_authorized/birthdays",
        "/_authorized/welcome",
        "/_authorized/welcome-event",
        "/_authorized/welcome-event-declined",
        "/_authorized/welcome-google",
        "/_authorized/",
        "/_authorized/events/new",
        "/_authorized/settings/appearance",
        "/_authorized/settings/cancel-subscription",
        "/_authorized/settings/notifications",
        "/_authorized/settings/video-call",
        "/_authorized/slots/google-init",
        "/_authorized/slots/onboarding",
        "/_authorized/slots/ready",
        "/_authorized/slots/settings",
        "/_authorized/slots/video-call-settings",
        "/_authorized/stacks/new",
        "/_authorized/settings/",
        "/_authorized/events/$eventId/attend",
        "/_authorized/events/$eventId/created",
        "/_authorized/events/$eventId/draft",
        "/_authorized/events/$eventId/edit",
        "/_authorized/events/$eventId/join",
        "/_authorized/events/$eventId/maybe",
        "/_authorized/events/$eventId/participants",
        "/_authorized/events/$eventId/stories-share",
        "/_authorized/events/$eventId/view",
        "/_authorized/settings/google/$accountId",
        "/_authorized/slots/$eventId/attend",
        "/_authorized/slots/$slotId/view",
        "/_authorized/stacks/$stackId/edit",
        "/_authorized/stacks/$stackId/view",
        "/_authorized/slots/$eventId/$slotId/reschedule"
      ]
    },
    "/google-auth": {
      "filePath": "google-auth.tsx"
    },
    "/google-auth-callback": {
      "filePath": "google-auth-callback.tsx"
    },
    "/zoom-success": {
      "filePath": "zoom-success.tsx"
    },
    "/_authorized/_withTabs": {
      "filePath": "_authorized/_withTabs.tsx",
      "parent": "/_authorized",
      "children": [
        "/_authorized/_withTabs/feed",
        "/_authorized/_withTabs/feed-welcome",
        "/_authorized/_withTabs/slots",
        "/_authorized/_withTabs/stacks"
      ]
    },
    "/_authorized/birthdays": {
      "filePath": "_authorized/birthdays.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/welcome": {
      "filePath": "_authorized/welcome.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/welcome-event": {
      "filePath": "_authorized/welcome-event.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/welcome-event-declined": {
      "filePath": "_authorized/welcome-event-declined.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/welcome-google": {
      "filePath": "_authorized/welcome-google.ts",
      "parent": "/_authorized"
    },
    "/_authorized/": {
      "filePath": "_authorized/index.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/_withTabs/feed": {
      "filePath": "_authorized/_withTabs/feed.tsx",
      "parent": "/_authorized/_withTabs"
    },
    "/_authorized/_withTabs/feed-welcome": {
      "filePath": "_authorized/_withTabs/feed-welcome.tsx",
      "parent": "/_authorized/_withTabs"
    },
    "/_authorized/_withTabs/slots": {
      "filePath": "_authorized/_withTabs/slots.tsx",
      "parent": "/_authorized/_withTabs"
    },
    "/_authorized/_withTabs/stacks": {
      "filePath": "_authorized/_withTabs/stacks.tsx",
      "parent": "/_authorized/_withTabs"
    },
    "/_authorized/events/new": {
      "filePath": "_authorized/events/new.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/settings/appearance": {
      "filePath": "_authorized/settings/appearance.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/settings/cancel-subscription": {
      "filePath": "_authorized/settings/cancel-subscription.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/settings/notifications": {
      "filePath": "_authorized/settings/notifications.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/settings/video-call": {
      "filePath": "_authorized/settings/video-call.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/google-init": {
      "filePath": "_authorized/slots/google-init.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/onboarding": {
      "filePath": "_authorized/slots/onboarding.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/ready": {
      "filePath": "_authorized/slots/ready.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/settings": {
      "filePath": "_authorized/slots/settings.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/video-call-settings": {
      "filePath": "_authorized/slots/video-call-settings.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/stacks/new": {
      "filePath": "_authorized/stacks/new.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/settings/": {
      "filePath": "_authorized/settings/index.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/attend": {
      "filePath": "_authorized/events/$eventId/attend.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/created": {
      "filePath": "_authorized/events/$eventId/created.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/draft": {
      "filePath": "_authorized/events/$eventId/draft.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/edit": {
      "filePath": "_authorized/events/$eventId/edit.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/join": {
      "filePath": "_authorized/events/$eventId/join.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/maybe": {
      "filePath": "_authorized/events/$eventId/maybe.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/participants": {
      "filePath": "_authorized/events/$eventId/participants.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/stories-share": {
      "filePath": "_authorized/events/$eventId/stories-share.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/events/$eventId/view": {
      "filePath": "_authorized/events/$eventId/view.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/settings/google/$accountId": {
      "filePath": "_authorized/settings/google.$accountId.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/$eventId/attend": {
      "filePath": "_authorized/slots/$eventId/attend.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/$slotId/view": {
      "filePath": "_authorized/slots/$slotId/view.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/stacks/$stackId/edit": {
      "filePath": "_authorized/stacks/$stackId/edit.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/stacks/$stackId/view": {
      "filePath": "_authorized/stacks/$stackId/view.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/slots/$eventId/$slotId/reschedule": {
      "filePath": "_authorized/slots/$eventId/$slotId/reschedule.tsx",
      "parent": "/_authorized"
    }
  }
}
ROUTE_MANIFEST_END */
